export const EXCHANGE_VALUE = 1000;
